import { ref } from '@vue/reactivity'
import { computed } from '@vue/runtime-core'

const images = ref([])
const imageIndex = ref(-1)
const imageVisible = ref(false)

export default function useImageViewer() {
  const showSingleImage = (img) => {
    images.value = img
    setVisible()
  }

  const showImageIndex = (imgs, idx) => {
    images.value = [...imgs]

    setIndex(idx)
    setVisible()
  }

  const setVisible = (isVisible = true) => {
    imageVisible.value = isVisible
  }

  const setIndex = (idx) => {
    imageIndex.value = idx
  }

  return {
    showImageIndex,
    showSingleImage,
    setVisible,
    setIndex,
    images: computed(() => images.value),
    imageVisible,
    imageIndex,
  }
}
